module.exports = __webpack_public_path__ + "static/img/event2.bea080b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/event2.png
// module id = VlKY
// module chunks = 1